var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"contents"},[_c('Sidebar'),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /photo-order/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29da05ed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/photo-order/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Lab.vue
// module id = null
// module chunks = 